import api from './api';

class DepartmentService {
  // Get all departments
  async getDepartments(activeOnly = true) {
    try {
      const response = await api.get('/departments', {
        params: { active_only: activeOnly }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching departments:', error);
      throw this.handleError(error);
    }
  }

  // Get department by ID
  async getDepartmentById(id) {
    try {
      const response = await api.get(`/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching department:', error);
      throw this.handleError(error);
    }
  }

  // Create new department
  async createDepartment(departmentData) {
    try {
      const response = await api.post('/departments', departmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating department:', error);
      throw this.handleError(error);
    }
  }

  // Update department
  async updateDepartment(id, departmentData) {
    try {
      const response = await api.put(`/departments/${id}`, departmentData);
      return response.data;
    } catch (error) {
      console.error('Error updating department:', error);
      throw this.handleError(error);
    }
  }

  // Delete department
  async deleteDepartment(id) {
    try {
      const response = await api.delete(`/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting department:', error);
      throw this.handleError(error);
    }
  }

  // Get departments formatted for dropdown
  async getDepartmentOptions(activeOnly = true) {
    try {
      const response = await this.getDepartments(activeOnly);
      if (response.success && response.data) {
        return response.data.map(dept => ({
          value: dept.code,
          label: dept.name,
          id: dept.id
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching department options:', error);
      return [];
    }
  }

  // Error handling
  handleError(error) {
    if (error.response) {
      return {
        success: false,
        message: error.response.data?.message || 'An error occurred',
        error: error.response.data?.error || error.message,
        status: error.response.status
      };
    } else if (error.request) {
      return {
        success: false,
        message: 'Network error. Please check your connection.',
        error: 'Network Error'
      };
    } else {
      return {
        success: false,
        message: error.message || 'An unexpected error occurred',
        error: error.message
      };
    }
  }
}

const departmentService = new DepartmentService();
export default departmentService;